import { FormattedMessage } from 'react-intl';
import type { UpgradeRequiredDetail } from '@/lib/billing-events';
import { UpgradeDialogPanel } from './UpgradeDialogPanel';

interface ManageUpgradeDialogContentProps {
    detail: UpgradeRequiredDetail;
    onClose: () => void;
    onViewPlans: () => void;
    canViewPlans: boolean;
}

export function ManageUpgradeDialogContent({
    detail,
    onClose,
    onViewPlans,
    canViewPlans,
}: ManageUpgradeDialogContentProps) {
    return (
        <UpgradeDialogPanel
            eyebrow={<FormattedMessage id="a0b1c2d3-1111-4a2b-8c3d-000000000915" defaultMessage="Subscription required" />}
            title={<FormattedMessage id="a0b1c2d3-1111-4a2b-8c3d-000000000916" defaultMessage="Keep managing your home" />}
            description={detail.message || (
                <FormattedMessage
                    id="a0b1c2d3-1111-4a2b-8c3d-000000000919"
                    defaultMessage="Subscribe to Manage to keep your household organized with your co-owners."
                />
            )}
            benefits={[
                <FormattedMessage key="organization" id="a0b1c2d3-1111-4a2b-8c3d-000000000913" defaultMessage="One shared place for home tasks, documents, and decisions" />,
                <FormattedMessage key="coordination" id="a0b1c2d3-1111-4a2b-8c3d-000000000914" defaultMessage="Stay aligned with every co-owner" />,
            ]}
            cta={<FormattedMessage id="a0b1c2d3-1111-4a2b-8c3d-000000000917" defaultMessage="View Manage plan" />}
            dismissAction={<FormattedMessage id="a0b1c2d3-1111-4a2b-8c3d-000000000920" defaultMessage="Not now" />}
            footer={<FormattedMessage id="a0b1c2d3-1111-4a2b-8c3d-000000000918" defaultMessage="Flexible monthly plan · cancel anytime" />}
            onClose={onClose}
            onViewPlans={onViewPlans}
            canViewPlans={canViewPlans}
        />
    );
}